export const baseURL = process.env.REACT_APP_BASE_URL;


// export const appURL = "https://talentspotifyapp.com/api";
export const appURL = "https://test-ai.talentspotify.com/api";
// export const appURL = "http://localhost:4000/api";
//  export const appURL = "https://vihanga.talentspotifyapp.com/api";

export const PsychometricURL = "https://test.talentspotifyapp.com/api";


// export const UiURL="https://talentspotifyapp.com"
// export const UiURL="https://test-ai.talentspotify.com"
export const UiURL="https://vihanga.talentspotifyapp.com"

export const taraURL = "https://test-bias.talentspotify.com";
